import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'

import 'chartjs-plugin-doughnutlabel'
import { getDiffDirectionSymbol } from '../../BuildingAnalytics/helpers'

const CHART_COLORS = [
  'rgba(255, 99, 132, 1)',
  '#EAE9E9',
  'rgba(153, 102, 255, 1)',
  'rgba(255, 159, 64, 1)',
]
const CHART_LABELS = ['1 Red', '4 Green', '5 Purple', '6 Orange']
const CHART_LABEL = '# of Votes'
const CHART_DATA = [12, 19, 2, 3]

const defaultData = {
  labels: CHART_LABELS,
  datasets: [
    {
      label: CHART_LABEL,
      data: CHART_DATA,
      backgroundColor: CHART_COLORS,
      borderColor: CHART_COLORS,
      borderWidth: 1,
    },
  ],
}

const DoughnutChart = ({
  data = defaultData,
  options,
  halfChart,
  width,
  height,
  tooltipCallbacks,
  disableLegend = false,
}) => {
  const defaultOptions = {
    cutoutPercentage: 60,
    rotation: Math.PI,
    maintainAspectRatio: true,
    responsive: false,
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: false,
        boxHeight: 12,
        boxWidth: 12,
      },
      ...(disableLegend && {
        onClick: null,
        onHover: null,
      }),
    },
    plugins: {
      innerText: true,
      datalabels: {
        display: false,
      },
      doughnutlabel: {
        labels: [
          {
            text: '0',
            font: {
              size: '25',
            },
            color: 'black',
          },
          {
            text: '▼ 10.00%',
            font: {
              size: '15',
              weight: '500',
            },
            color: '#548671',
          },
        ],
      },
    },
    tooltips: {
      callbacks: tooltipCallbacks || {
        label: (tooltipItem, data) => ` ${data.labels[tooltipItem['index']]}`,
        afterLabel: function (tooltipItem, data) {
          let dataset = data['datasets'][0]
          return ` ${dataset.data[tooltipItem['index']]}`
        },
        footer: function (tooltipItems, data) {
          const tooltipItem = tooltipItems[0]
          let dataset = data.datasets[0]
          return `${getDiffDirectionSymbol(dataset.diff[tooltipItem.index])} ${
            dataset.diff[tooltipItem.index]
          }`
        },
      },
      caretSize: 0,
      backgroundColor: 'rgba(255,255,255,0.9)',
      titleFontSize: 16,
      borderColor: '#EAE9E9',
      cornerRadius: 6,
      borderWidth: 1,
      titleFontColor: '#0066ff',
      bodyFontColor: '#000',
      bodyFontSize: 14,
      footerFontColor: '#548671',
      footerFontSize: 14,
      footerFontStyle: 'normal',
    },
  }

  const getOptions = (halfChart) => {
    const optionsToAdd = halfChart && {
      rotation: Math.PI,
      circumference: Math.PI,
      maintainAspectRatio: true,
      responsive: true,
    }
    const updatedOptions = { ...defaultOptions, ...options }

    if (halfChart) {
      updatedOptions.plugins.doughnutlabel.labels = [
        {
          text: '-',
          font: {
            size: '35',
          },
          color: 'transparent',
        },
        ...updatedOptions.plugins.doughnutlabel.labels,
      ]
    }

    return { ...optionsToAdd, ...updatedOptions }
  }

  return <Doughnut width={width} height={height} options={getOptions(halfChart)} data={data} />
}

DoughnutChart.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  halfChart: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  tooltipCallbacks: PropTypes.object,
  disableLegend: PropTypes.bool,
}

export default DoughnutChart
